var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"rules":[_vm.emailValidation],"loading":_vm.loading,"label":_vm.label,"disabled":_vm.disabled,"value":_vm.value},on:{"input":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }